module.exports = __webpack_public_path__ + "img/sv8.ac3d657b.svg";